import { isUpdateDonationFailedResponse, Name as ErrorEventName } from '@ori-events/update-donation-failed';
import { HttpMethod } from '@ori/checkout-utils';
import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
export async function updateDonationHandler({
  detail: {
    choiceId,
    checked
  }
}) {
  const response = await fetch(RequestUrl.UpdateDonation, getHttpRequestSettings({
    choiceId,
    checked
  }, HttpMethod.Post));
  const data = convertToCamelCase(await response.json());
  if (isUpdateDonationFailedResponse(data)) {
    const event = new CustomEvent(ErrorEventName, {
      detail: data
    });
    window.dispatchEvent(event);
    return false;
  }
  return data;
}
//# sourceMappingURL=updateDonationHandler.js.map